import { useEffect, useState } from 'react';
import { resolveMotionPolicy } from '../lib/motionPolicy';

const QUERY = '(prefers-reduced-motion: reduce)';

// Thin hook over resolveMotionPolicy (D5): reads the live OS prefers-reduced-motion,
// guarded for SSR/jsdom (no window.matchMedia), and re-resolves on OS change. The OS
// setting is the non-overridable floor. Wave 2: threads the user's reducedMotion + mode
// preferences into the resolver (this hook is the ONLY conduit by which prefs reach it —
// the provider must not read reducedMotion directly). Arg-less callers are unchanged.
export function useMotionPolicy({ reducedMotion, mode } = {}) {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setReduced(e.matches);
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else if (mq.removeListener) mq.removeListener(onChange);
    };
  }, []);

  return resolveMotionPolicy({ prefersReducedMotion: reduced, reducedMotion, mode });
}
